module.exports = __webpack_public_path__ + "static/media/notification.64e4fc9b.svg";